import(/* webpackMode: "eager" */ "/codebuild/output/src4154609036/src/seedkit-admin/src/app/page.js");
